import { listRemovalError } from "@planzone/dto";
import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    getRemoveListError({ uuid }) {
      const req = getState().find(({ list }) => list.uuid === uuid);

      return req ? req.error : listRemovalError;
    },
    isRemoveListRequestFailure(list) {
      const state = getState().find(({ list: { uuid } }) => uuid === list.uuid);

      return state ? state.request.isFailure : false;
    },
    isRemoveListRequestPending(list) {
      const state = getState().find(({ list: { uuid } }) => uuid === list.uuid);

      return state ? state.request.isPending : false;
    },
    isRemoveListRequestSuccess(list) {
      const state = getState().find(({ list: { uuid } }) => uuid === list.uuid);

      return state ? state.request.isSuccessful : false;
    },
  };
}

export { createSelector };
